// Only these categories have public labels in the Originator Rating Policy.
export const getOriginatorRatingLabelId = (rating?: number | null): string | undefined => {
  if (rating == null || !Number.isFinite(rating) || rating < 70 || rating > 100) return undefined;
  if (rating >= 90) return 'originator.rating.prime';
  if (rating >= 80) return 'originator.rating.trusted';
  return 'originator.rating.approved';
};
